<template>
  <ImgLazy
    :image-url="gifteeAppIcon"
    alt-text="giftee-app-icon"
    aspect-ratio="1 / 1"
  />
</template>

<script>
import ImgLazy from '../images/ImgLazy.vue'
import GifteeIcon from '../../../../../images/icons/giftee-app-icon.png'
export default {
  components: {
    ImgLazy
  },
  data() {
    return {
      gifteeAppIcon: ''
    }
  },
  mounted() {
    this.gifteeAppIcon = GifteeIcon
  }
}
</script>
